import { render, staticRenderFns } from "./IDoc.vue?vue&type=template&id=330843e2"
import script from "./IDoc.vue?vue&type=script&lang=js"
export * from "./IDoc.vue?vue&type=script&lang=js"
import style0 from "./IDoc.vue?vue&type=style&index=0&id=330843e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports